import { render, staticRenderFns } from "./registerSuccessTip.vue?vue&type=template&id=99a6b520&scoped=true&"
import script from "./registerSuccessTip.vue?vue&type=script&lang=js&"
export * from "./registerSuccessTip.vue?vue&type=script&lang=js&"
import style0 from "./registerSuccessTip.vue?vue&type=style&index=0&id=99a6b520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a6b520",
  null
  
)

export default component.exports